import { Pipe, PipeTransform } from "@angular/core";
import { DependencyTrackVulnerabilityDetails } from "../../interfaces/dependency-track-vulnerability-details";
import { Vulnerability } from "../../interfaces/vulnerability";
import { Severity } from "../../enums/severity";

@Pipe({
  name: "vulnerabilitiesDetail",
})
export class VulnerabilitiesDetailPipe implements PipeTransform {
  transform(value: DependencyTrackVulnerabilityDetails): Array<Vulnerability> {
    return value?.details?.findings.map((finding) => ({
      vulnerability: finding.vulnerability?.vulnId || "N/A",
      name:
        finding.vulnerability?.cweName ||
        finding.vulnerability?.vulnId ||
        "N/A",
      severity: finding.vulnerability?.severity || Severity.Unassigned,
      dependency: finding.component?.group
        ? `${finding.component.group}/${finding.component.name}`
        : finding.component?.name || "N/A",
      version: finding.component?.version || "N/A",
      lastVersion: finding.component?.latestVersion || "N/A",
      classifiedBy: finding.vulnerability?.source || "N/A",
      classifiedOn: finding.attribution.attributedOn,
      title: finding.vulnerability?.title || "",
      description: finding.vulnerability?.description || "",
      aliases: finding.vulnerability?.aliases || [],
      finding,
    }));
  }
}
